<script>
import axios from "axios";
import Loading from "../../Loading.vue";
import _ from "lodash";

export default {
  name: "EffContractAutoCalculateDetailTable",
  components: {Loading},

  props: {
    personEffContractId: {
      type: [Number, String],
    },

    personId: {
      type: [Number, String]
    }
  },

  data() {
    return {
      data: {},
      loading: true,
      headers: [],
      page: 1,
      itemsPerPage: 12,
    }
  },

  watch: {
    personEffContractId: function () {
      if(!_.isNil(this.personEffContractId)) {
        this.getCalculationDetail();
      } else {
        this.loading = true;
        this.data = [];
        this.headers = [];
        this.page = 1;
      }
    }
  },

  computed: {
    items() {
      return this.flattenStructure();
    },

    numberOfPages () {
      return Math.ceil(this.items.length / this.itemsPerPage)
    },
  },

  mounted() {
    if(!_.isNil(this.personEffContractId)) {
      this.getCalculationDetail();
    }
  },

  methods: {
    async getCalculationDetail() {
      try {
        const res = await axios.get(`/eff_contract/person_eff_contracts/${this.personEffContractId}/auto_calculate_detail.json`,
          {params: {
              person_id: this.personId,
            }
          }
        );
        this.data = res.data.result;
        this.headers = res.data.headers.map(header => {return {text: header.text, value: header.value}})
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
      }
    },

    flattenObject(obj, parentKey = '', result = {}) {
      _.forOwn(obj, (value, key) => {
        if (_.isObject(value) && !_.isArray(value)) {
          this.flattenObject(value, key, result);
        } else {
          result[key] = value;
        }
      });
      return result;
    },

    flattenStructure() {
      let result = [];

      function recursiveFlatten(currentObj, parentData = {}) {
        if (_.isArray(currentObj)) {
          currentObj.forEach(item => recursiveFlatten(item, _.cloneDeep(parentData)));
        } else if (_.isObject(currentObj)) {
          const combinedData = {...parentData};
          const keys = _.keys(currentObj);
          let hasNestedArray = false;

          keys.forEach(key => {
            if (_.isArray(currentObj[key])) {
              hasNestedArray = true;
              currentObj[key].forEach(nestedItem => {
                recursiveFlatten(nestedItem, {...combinedData, [key]: nestedItem});
              });
            } else if (_.isObject(currentObj[key])) {
              this.flattenObject(currentObj[key], '', combinedData);
            } else {
              combinedData[key] = currentObj[key];
            }
          });

          if (!hasNestedArray) {
            result.push(combinedData);
          }
        }
      }

      recursiveFlatten(this.data);
      return result;
    },

  }
}
</script>

<template>
  <loading :loading="loading" :height-card="15">
    <v-data-table
      :headers="headers"
      :items="items"
      class="elevation-0"
      :items-per-page.sync="itemsPerPage"
      :page.sync="page"
      hide-default-footer
    >

      <template v-slot:top>
        <v-toolbar>
          <v-toolbar-title>Количество записей : {{items.length}}</v-toolbar-title>
        </v-toolbar>
      </template>

      <template #footer>
        <v-divider/>
        <v-row
          class="pb-2 mt-2"
          align="center"
          justify="center">
          <v-col cols="12" class="text-center">
            <v-pagination
              circle
              color="teal darken-3"
              v-model="page"
              :length="numberOfPages"
              :total-visible="8">
            </v-pagination>
          </v-col>
        </v-row>
      </template>

    </v-data-table>
  </loading>
</template>

<style scoped>
</style>